import { render, staticRenderFns } from "./witem.vue?vue&type=template&id=1632d542&"
import script from "./witem.vue?vue&type=script&lang=js&"
export * from "./witem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports